var _path, _path2, _circle, _path3, _mask, _rect, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScaleWithConfidence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 77,
    viewBox: "0 0 72 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 74.5V67",
    stroke: "#D3D3D3",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 38L12.5751 34.1501C12.5297 34.0593 12.5437 33.9501 12.6105 33.8737L16 30",
    stroke: "#E2E2E2",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 34,
    r: 5.5,
    stroke: "#2C3057",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 74.5V49.0446C12 48.2125 11.0429 47.7444 10.3861 48.2553L8.39416 49.8045C7.91937 50.1738 7.87567 50.8757 8.301 51.301L10.3867 53.3867C10.7386 53.7386 10.7782 54.2957 10.4796 54.6938L8.69181 57.0776C8.32668 57.5644 7.61501 57.615 7.1847 57.1847L3.53553 53.5355C1.58291 51.5829 1.58291 48.4171 3.53553 46.4645L9.70711 40.2929C9.89464 40.1054 10.149 40 10.4142 40H19.6736C19.8857 40 20.0923 39.9325 20.2636 39.8074L32.1571 31.116C32.6166 30.7802 33.2634 30.8951 33.5791 31.3687L35.4721 34.2082C35.7678 34.6517 35.6636 35.2492 35.2353 35.5664L22.9048 44.7002C22.6502 44.8888 22.5 45.1869 22.5 45.5037V51C22.5 51.5523 22.9477 52 23.5 52H28C30.4853 52 32.5 54.0147 32.5 56.5V64C32.5 64.5523 32.0523 65 31.5 65H28C27.4477 65 27 64.5523 27 64V60C27 59.4477 26.5523 59 26 59H19C18.4477 59 18 59.4477 18 60V74.5C18 75.0523 17.5523 75.5 17 75.5H13C12.4477 75.5 12 75.0523 12 74.5Z",
    fill: "#8E4BFF",
    fillOpacity: 0.3,
    stroke: "#2C3057",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_811_119",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 64.5,
    width: 18,
    height: 12,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 64.5,
    width: 18,
    height: 12,
    rx: 1,
    stroke: "#2C3057",
    strokeWidth: 4,
    mask: "url(#path-5-inside-1_811_119)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72 8L60.4691 8.60913L66.7621 18.2906L72 8ZM42.545 28.3384L64.999 13.7433L63.909 12.0665L41.455 26.6616L42.545 28.3384Z",
    fill: "#2C3057"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25L56.4887 25.9077L63.0304 35.4229L68 25ZM44.5665 42.324L61.1502 30.9228L60.0171 29.2747L43.4335 40.676L44.5665 42.324Z",
    fill: "#2C3057"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55 0L43.4887 0.90768L50.0304 10.4229L55 0ZM31.5665 17.324L48.1502 5.9228L47.0171 4.27472L30.4335 15.676L31.5665 17.324Z",
    fill: "#2C3057"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47L42 43",
    stroke: "#2C3057",
    strokeWidth: 2,
    strokeDasharray: "4 1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22L29 18",
    stroke: "#2C3057",
    strokeWidth: 2,
    strokeDasharray: "4 1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleWithConfidence);
export default __webpack_public_path__ + "static/media/scaleWithConfidence.ac4104f836292bed6640e6804c89e460.svg";
export { ForwardRef as ReactComponent };